"use client";
import React from 'react';
import CollectionsPage from "./CollectionsPage";

const Codex = () => {
  return <CollectionsPage documentId={'2izXHCrmJ684AnZ5X'} />
};

export default Codex;



